import { latestPlanVersion, PlanVersion } from '../planVersion';

export interface FeatureProps {
  planVersion: PlanVersion;
}

export default class SubscriptionFeature {
  planVersion: PlanVersion;

  constructor(props?: FeatureProps) {
    this.planVersion = latestPlanVersion;
    if (props) {
      this.planVersion = props.planVersion;
    }
  }
}
